/* Woorden en kleuren voor Organisaties en Contacten. */

export const STATUS_LABEL: Record<string, string> = {
  prospect: 'Prospect',
  lead: 'Lead',
  klant: 'Klant',
  actief: 'Actief',
  inactief: 'Inactief',
};

export const STATUS_KLEUR: Record<string, string> = {
  prospect: 'bg-slate-100 text-slate-700 border-slate-200',
  lead: 'bg-blue-50 text-blue-800 border-blue-200',
  klant: 'bg-green-50 text-green-800 border-green-200',
  actief: 'bg-green-50 text-green-800 border-green-200',
  inactief: 'bg-zinc-100 text-zinc-600 border-zinc-200',
};

export const CLASSIFICATIE_LABEL: Record<string, string> = {
  klant: 'Klant',
  leverancier: 'Leverancier',
};

export const statusLabel = (s: string | null | undefined) => (s ? STATUS_LABEL[s] ?? s : 'Onbekend');
export const classificatieLabel = (s: string | null | undefined) => (s ? CLASSIFICATIE_LABEL[s] ?? s : 'Onbekend');

/** Charging: status van een Opportunity (useOpportunities) en fase van een Kavel. */
const KANS_LABEL: Record<string, string> = {
  prospect: 'Prospect',
  in_gesprek: 'In gesprek',
  offerte: 'Offerte',
  onderhandeling: 'Onderhandeling',
  gewonnen: 'Gewonnen',
  verloren: 'Verloren',
};
export const kansLabel = (s: string | null | undefined) => (s ? KANS_LABEL[s] ?? s : '—');
export const kavelLabel = (s: string | null | undefined) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '—');

/** 'Jan de Vries'; zonder naam 'Naamloos contact'. */
export function contactNaam(voornaam: string | null | undefined, achternaam: string | null | undefined): string {
  return [voornaam, achternaam].map((d) => d?.trim()).filter(Boolean).join(' ') || 'Naamloos contact';
}

/** Sorteren op achternaam zonder tussenvoegsel: 'van Beek' staat bij de B. */
const TUSSENVOEGSEL = /^(?:(?:van|de|der|den|het|'t|ter|ten|te|in|op|aan|bij|uit|voor|la|le|du|da|di|del)\s+)+/i;
export function sorteerNaam(achternaam: string | null | undefined, voornaam: string | null | undefined): string {
  const a = (achternaam ?? '').trim().replace(TUSSENVOEGSEL, '');
  return `${a || (voornaam ?? '').trim()} ${(voornaam ?? '').trim()}`.trim().toLowerCase();
}

/** Een adres uit organizations.addresses (jsonb) als één regel. */
export interface Adres {
  street?: string | null;
  number?: string | null;
  zipcode?: string | null;
  city?: string | null;
  country?: string | null;
}

export function adresRegel(a: Adres): string {
  const straat = [a.street, a.number].map((d) => d?.toString().trim()).filter(Boolean).join(' ');
  const plaats = [a.zipcode, a.city].map((d) => d?.toString().trim()).filter(Boolean).join(' ');
  const land = a.country && !/^(nl|nederland|netherlands|the netherlands)$/i.test(a.country.trim()) ? a.country.trim() : null;
  return [straat, plaats, land].filter(Boolean).join(', ');
}

export function adressenUit(v: unknown): Adres[] {
  if (!Array.isArray(v)) return [];
  return v.filter((a) => a && typeof a === 'object') as Adres[];
}

/** De plaats van het eerste adres met een plaats. */
export function plaatsVan(adressen: Adres[]): string | null {
  return adressen.find((a) => a.city?.trim())?.city?.trim() ?? null;
}

/** 'greenvision.energy' uit 'https://www.greenvision.energy/contact'. */
export function domein(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  try {
    return new URL(url.startsWith('http') ? url : `https://${url}`).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** Een link die de browser opent: zonder schema krijgt hij https://. */
export const webadres = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);
